import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/site/Navigation";
import Footer from "./components/site/Footer";
import Home from "./pages/Home";
import Video from "./pages/Video";
import Gallery from "./pages/Gallery";
import { LanguageProvider } from "./i18n";

function App() {
    return (
        <div className="App">
            <LanguageProvider>
                <BrowserRouter>
                    <Navigation />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/video" element={<Video />} />
                        <Route path="/gallery" element={<Gallery />} />
                    </Routes>
                    <Footer />
                </BrowserRouter>
            </LanguageProvider>
        </div>
    );
}

export default App;
